export const MENU_STATE_KEY = 'menu_state';
export const TOKEN_KEY = 'token';
export const KC_REFRESH_TOKEN_KEY = 'kc_refresh_token';
export const KC_ID_TOKEN_KEY = 'kc_id_token';
